import { Sport } from './../models/sport';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Http, RequestOptions, Headers } from '@angular/http';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/toPromise';
import { environment } from '../../environments/environment';

@Injectable()
export class AdminsService {


    constructor(public http: HttpClient) { }

    getReservationHistory(data): Observable<HttpResponse<any>> {
        let params = new HttpParams().set('cityId', data.cityId);
        console.log('Params to get admins:', params);
        let headers = new HttpHeaders().set('authorizationtoken', data.authorizationToken);
        const options = { params: params, headers: headers };
        const url = environment.apiUrl + '/reservations/history';
        return this.http.get<any>(url, { observe: 'response', params: params, headers: headers });
       
    }

    public getAdmins(data): Observable<HttpResponse<any>> {
        let params = new HttpParams().set('cityId', data.cityId);
        console.log('Params to get admins:', params);
        let headers = new HttpHeaders().set('authorizationtoken', data.authorizationToken);
        const options = { params: params, headers: headers };
        const url = environment.apiUrl + '/admin';
        return this.http.get<any>(url, { observe: 'response', params: params, headers: headers });
    }
    public checkUsername(data): Observable<HttpResponse<any>> {
        let params = new HttpParams();
        params = params.append('username', data.username);
        params = params.append('cityId', data.cityId);
        console.log('Params to get admins:', params);
        let headers = new HttpHeaders().set('authorizationtoken', data.authorizationToken);
        const options = { params: params, headers: headers };
        const url = environment.apiUrl + '/admin/checkusername';
        return this.http.get<any>(url, { observe: 'response', params: params, headers: headers });
    }
    public parseData = (data) => {
        const body = data.json();
        return body || {};
    }

    public handleError = (err) => {
        return Observable.throw(err);
    }

    deleteAdmin(data): Observable<HttpResponse<any>> {
        let params = new HttpParams();
        params = params.append('cityId', data.cityId);
        params = params.append('username', data.username);
        console.log('Params to delete park:', params);
        let headers = new HttpHeaders().set('authorizationtoken', data.authorizationToken);
        const url = environment.apiUrl + '/admin';
        return this.http.delete<any>(url, { observe: 'response', params: params, headers: headers });
    }
    public addAdmin(data, data1): Observable<HttpResponse<any>> {
        let params = new HttpParams();
        params = params.append('firstName', data.firstName);
        params = params.append('lastName', data.lastName);
        params = params.append('username', data.username);
        params = params.append('email', data.email);
        params = params.append('phoneNumber', data.phoneNumber);
        params = params.append('permission', data.permission);
        params = params.append('cityId', data1.cityId);
        console.log('Params to add park:', params);
        let headers = new HttpHeaders().set('authorizationtoken', data1.authorizationToken);
        const url = environment.apiUrl + '/admin';
        return this.http.post<any>(url, '', { observe: 'response', params: params, headers: headers });
    }
    public editAdmin(data): Observable<HttpResponse<any>> {
        let params = new HttpParams();
        params = params.append('firstName', data.firstName);
        params = params.append('lastName', data.lastName);
        params = params.append('username', data.username);
        params = params.append('email', data.email);
        params = params.append('phoneNumber', data.phoneNumber);
        params = params.append('existingPermission', data.existingPermission);
        params = params.append('newPermission', data.newPermission);
        params = params.append('cityId', data.cityId);
        console.log('Params to edit park:', params);
        let headers = new HttpHeaders().set('authorizationtoken', data.authorizationToken);
        const url = environment.apiUrl + '/admin';
        return this.http.put<any>(url, '', { observe: 'response', params: params, headers: headers });
    }

    getPartnerInvitations(partner_id) {
        const url = environment.apiUrl + '/partners/admins/invitations?partner_id='+partner_id;
        return this.http.get(url);
    }

    sendInvitation(partner_id,partner_name,email){
        let headers = new HttpHeaders();
        headers.append('Content-Type', 'application/json');
        let params = new HttpParams();
        params = params.append('partner_id', partner_id);
        params = params.append('partner_name', partner_name);
        params = params.append('email', email);
        const url = environment.apiUrl + '/partners/admins/invitations';
        return this.http.post<any>(url, '', { observe: 'response', params: params, headers: headers });
    }

    getPartnerList(){
        const url=environment.apiUrl + '/partners';
        return this.http.get(url);
    }

    updatePartnerStatusToCityAdmin(pid,pemail){
        let params = new HttpParams();
        params = params.append('partner_id', pid);
        params = params.append('email', pemail);
        console.log('Params to edit park:', params);
        const url = environment.apiUrl + '/partners/admins/status';
        return this.http.put<any>(url, '', { observe: 'response', params: params });
    }
    getAdminProfile(repID) :Observable<HttpResponse<any>> {
        let params = new HttpParams();
        params = params.append('Rep_Id',repID);
        let headers = new HttpHeaders().set('Content-Type', 'application/json');
        const url=  environment.usersessionUrl + '/facility/profile';
        return this.http.get<any>(url,{ observe: 'response', params: params, headers: headers })

    }

    updateAdminProfile(data):Observable<HttpResponse<any>> {
        let params = new HttpParams();
        params = params.append('Rep_Id',data.repID);
        params = params.append('First_Name',data.first_name);
        params = params.append('Last_Name',data.last_name);
        params = params.append('Phone_Number',data.Phone_Number);
        console.log(params)
        let headers = new HttpHeaders().set('Content-Type', 'application/json');
        const url=  environment.usersessionUrl + '/facility/profile';
        return this.http.put<any>(url,'',{ observe: 'response', params: params, headers: headers })

    }

    getAdminActiveStatus(repid):Observable<HttpResponse<any>>  {
        let params = new HttpParams();
        params = params.append('rep_id',repid);
        let headers = new HttpHeaders().set('Content-Type', 'application/json');
        const url=  environment.facilityUrl + '/representatives/activity/status';
        return this.http.get<any>(url,{ observe: 'response', params: params, headers: headers })
    }

    getAdminLoginHistory(repid):Observable<HttpResponse<any>> {
        let params = new HttpParams();
        params = params.append('rep_id',repid);
        let headers = new HttpHeaders().set('Content-Type', 'application/json');
        const url=  environment.facilityUrl + '/representatives/activity/history';
        return this.http.get<any>(url,{ observe: 'response', params: params, headers: headers })
    }

}
